<template>
  <div class="slide-wrapper">
    <div v-if="type === PAGE_TYPES.NEWS" class="secondary__news p-8">
      <h2 class="secondary-page__title text-5xl uppercase mb-12">
        {{page.title}}
      </h2>
      <div class="secondary-page__content" v-html="page.content" />
    </div>
    <div v-if="type === PAGE_TYPES.PHOTO" class="secondary__canvas">
      <img :src="page.photo.url" class="w-full h-full object-cover" :alt="page.id">
    </div>
    <div v-if="type === PAGE_TYPES.VIDEO" class="secondary__canvas">
      <VideoPlayer :isInViewport="isInViewport" :src="page.video_media" />
    </div>
    <div v-if="type === PAGE_TYPES.YOUTUBE" class="secondary__canvas">
      <YoutubePlayer :isInViewport="isInViewport" :src="page.video_url" />
    </div>
  </div>
</template>

<script>
import VideoPlayer from './shared/VideoPlayer'
import YoutubePlayer from './shared/YoutubePlayer'
import { SECONDARY_PAGE_TYPES } from '../store'

export default {
  components: {
    VideoPlayer,
    YoutubePlayer
  },
  props: {
    page: Object,
    isInViewport: Boolean
  },
  data() {
    return {
      PAGE_TYPES: SECONDARY_PAGE_TYPES,
    }
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    type() {
      return this.page && this.page.slideType
    },
  }
}
</script>

<style>
.secondary__canvas {
  overflow: hidden;
}
</style>